export default {
  path: '/noPermission',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'noPermission',
  component: () => import('./index')
};
